import React, { useState, useRef, useEffect } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  FormControl,
  InputGroup,
  Box,
  Text
} from '@chakra-ui/react';
import OtpInput from '../../otp-verify-code';
import { VERIFY_OTP_MODAL } from '../../constants';

const VerifyOtpModal = ({
  isOpen,
  title = VERIFY_OTP_MODAL.title,
  desc = VERIFY_OTP_MODAL.desc.email,
  errorMessage,
  btnText = VERIFY_OTP_MODAL.btText,
  isLoading,
  setErrorMessage,
  onClick,
  onClose,
  handleResendOpt
}) => {
  const [otp, setOtp] = useState('');
  const [timeLeft, setTimeLeft] = useState(30);
  const timeRef = useRef(null);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    if (timeLeft <= 0) clearInterval(timer);

    return () => {
      clearInterval(timer);
    };
  }, [timeLeft]);

  useEffect(() => {
    if (timeRef.current) {
      timeRef.current.innerText = `0:${timeLeft}`;
    }
  }, [timeLeft, timeRef]);

  const onResendOtp = () => {
    setTimeLeft(30);
    if (handleResendOpt) handleResendOpt();
  };

  const onVerify = (e) => {
    e.preventDefault();
    const convertOtp = otp.split('').splice(0, 6).join('');
    onClick(convertOtp);
  };

  const onChange = (value) => {
    setOtp(value);
    if (setErrorMessage) setErrorMessage('');
  };

  return (
    <Modal isOpen={isOpen} isCentered onClose={onClose}>
      <ModalOverlay bg={'jet-black'} />
      <ModalContent
        borderRadius={'1.5rem'}
        maxWidth={{ base: 'auto', md: '30rem' }}
        p={{ base: '1.25rem', md: '2rem', '2xl': '3rem' }}
        bgColor={'#FAFAFA'}
        width={{ base: 'calc(100vw - 30px)', md: '100%' }}
        maxHeight={'85vh'}
        overflowY={'auto'}
      >
        <ModalHeader p="0" mb={{ base: '2rem', md: '1.938rem' }}>
          <Text
            fontSize={{ base: '2xl', '2xl': '4xl' }}
            fontWeight={'900'}
            mb={{ base: '5px', md: '0px' }}
          >
            {title}
          </Text>
          <Box display="flex">
            <Text fontSize="md" fontWeight={'400'}>
              {desc}
            </Text>
          </Box>
        </ModalHeader>

        <ModalBody p="0">
          <form onSubmit={onVerify}>
            <Box height={handleResendOpt ? '6.75rem' : '5.375rem'}>
              <FormControl isInvalid={!!errorMessage} w={'100%'}>
                <InputGroup w={'100%'} display="contents">
                  <OtpInput
                    value={otp}
                    valueLength={6}
                    onChange={onChange}
                    error={!!errorMessage}
                  />
                </InputGroup>
              </FormControl>

              {!!handleResendOpt && (
                <Text
                  mt={'1.25rem'}
                  fontSize={timeLeft === 0 ? 'lg' : 'md'}
                  fontWeight={timeLeft === 0 ? '900' : '400'}
                  align={'center'}
                  color={timeLeft === 0 ? 'green.500' : 'gray.600'}
                  onClick={() => (timeLeft === 0 ? onResendOtp() : () => {})}
                  cursor={`${timeLeft === 0 && 'pointer'}`}
                >
                  {timeLeft !== 0 ? (
                    <>
                      Resend OTP in{' '}
                      <Text as="span" color={'gray.600'} ref={timeRef}>
                        0:30
                      </Text>
                    </>
                  ) : (
                    'Resend OTP'
                  )}
                </Text>
              )}

              {!!errorMessage && <Text color={'red.500'}>{errorMessage}</Text>}
            </Box>

            <Button
              mt={{
                base: handleResendOpt ? '3rem' : '1.6rem',
                md: handleResendOpt ? '1.75rem' : '0.5rem'
              }}
              type="submit"
              w="100%"
              h="58px"
              colorScheme="green"
              isLoading={isLoading}
            >
              {btnText}
            </Button>
          </form>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default VerifyOtpModal;
